import {Typography} from '@material-ui/core';

const Label = ({label, children, style}) => {
    return (
        <Typography style={{ color: "#b1b1b1", marginRight: 8, fontSize: 14, ...style}}>{label}{children}</Typography>
    );
};

export default Label;
